import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name: 'replaceSpaces'})
export class PipeReplaceSpaces implements PipeTransform {
    transform(value: string): string {
    value = value.split(' ').join('_').toLowerCase();;
    
    return value;
  }
}